/**
 * IE11を判定する
 */
export default class EnvDetector {
  ua;

  constructor() {
    // UserAgent を取得し、全て小文字にする
    this.ua = window.navigator.userAgent.toLowerCase();

    // もしIEの場合は、body タグに「ie11」クラスを追加する
    if (this.isIE()) {
      this.addIEClass();
    }

    // もしMacの場合は、body タグに「mac」クラスを追加する
    if (this.isMac()) {
      this.addMacClass();
    }

    // もしSafariの場合は、body タグに「safari」クラスを追加する
    if (this.isSafari()) {
      this.addSafariClass();
    }

    // もしiOSの場合は、body タグに「ios」クラスを追加する
    if (this.isIOS()) {
      this.addIOSClass();
    }
  }

  /**
   * Internet Explorerかどうかを判定する
   * @returns {boolean}
   */
  isIE() {
    return (this.ua.indexOf('msie') >= 0 || this.ua.indexOf('trident') >= 0);
  }

  /**
   * Mac OSかどうかを判定する
   * @returns {boolean}
   */
  isMac() {
    // ただしiOSの場合は除外
    if (this.ua.indexOf('iphone') >= 0 || this.ua.indexOf('ipad') >= 0) {
      return false;
    }

    return (this.ua.indexOf('mac') >= 0);
  }

  isIOS() {
    return (this.ua.indexOf('iphone') >= 0 || this.ua.indexOf('ipad') >= 0);
  }

  /**
   * Safariかどうかを判定する
   * @returns {boolean}
   */
  isSafari() {
    return (this.ua.indexOf('safari') !== -1 && this.ua.indexOf('chrome') === -1 && this.ua.indexOf('edge') === -1);
  }

  /**
   * body タグに「ie11」クラスを追加する
   */
  addIEClass() {
    // IEのバージョンを、正規表現で取得する.
    var array = /(msie|rv:?)\s?([\d.]+)/.exec(this.ua);
    var version = (array) ? array[2] : '';

    // バージョンを整数の形式にする（11.0 -> 11）
    version = version.split('.')[0];

    // バージョン関係なくIE用のCSSを追加
    window.document.body.classList.add('ie');

    if (version === '11') {
      window.document.body.classList.add('ie11');
    }
  }

  /**
   * body タグに「mac」クラスを追加する
   */
  addMacClass() {
    window.document.body.classList.add('mac');
  }

  addSafariClass() {
    window.document.body.classList.add('safari');
  }

  addIOSClass() {
    window.document.body.classList.add('ios');
  }
}
